module.exports = __webpack_public_path__ + "img/ex-pin-arts-culture.a278581e.svg";